module.exports = __webpack_public_path__ + "img/store_bg.a173b98a.png";